import * as Icons from "lucide-react";
import { Lock } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { useAuth } from "@/context/AuthContext";

const ICON_MAP = {
  "shield-alert": "ShieldAlert", "arrow-left-right": "ArrowLeftRight", send: "Send", wallet: "Wallet",
  landmark: "Landmark", bitcoin: "Bitcoin", "building-2": "Building2", car: "Car", gem: "Gem",
  briefcase: "Briefcase", stamp: "Stamp", "heart-handshake": "HeartHandshake", "key-round": "KeyRound",
  plug: "Plug", "file-search": "FileSearch", banknote: "Banknote", "pen-tool": "PenTool", "scan-face": "ScanFace",
};

export default function Proximamente() {
  const { meta } = useAuth();
  const items = meta?.proximamente || [];

  return (
    <div>
      <PageHeader title="Módulos próximamente" subtitle="Verticales y servicios en preparación dentro de la plataforma multi-régimen" />
      <div className="p-6 md:p-8">
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {items.map((m) => {
            const Icon = Icons[ICON_MAP[m.icon]] || Icons.Sparkles;
            return (
              <div key={m.id} data-testid={`coming-${m.id}`}
                className="group relative overflow-hidden rounded-lg border border-slate-200 bg-white p-5 shadow-sm">
                <div className="absolute right-3 top-3 flex h-6 w-6 items-center justify-center rounded-full bg-slate-100">
                  <Lock className="h-3 w-3 text-slate-400" />
                </div>
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-slate-100 text-slate-400 transition-colors group-hover:bg-primary/10 group-hover:text-primary">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <p className="mt-3 text-sm font-medium text-slate-700">{m.nombre}</p>
                <span className="mt-2 inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-600">
                  Próximamente
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
